<template>
  <div>
    <h3 class="px-4">
      <span>{{ $t('templateWorkflows.title') }}</span>
    </h3>
  </div>
</template>
